import 'flatpickr/dist/themes/airbnb.css';
import React, { useContext } from 'react';
import { FieldRenderProps } from 'react-final-form';
import Flatpickr from 'react-flatpickr';

import { LocaleContext } from '../../../../../../../shared';

import { DatePickerLabel, DatePickerWrapper, PeriodWrapper } from './Period.styles';

export const Period = ({ input: { value, onChange } }: FieldRenderProps<any>) => {
  const localeContext = useContext(LocaleContext);
  const makeOnStartDateChange = (key: string) => (dates: Date[]) =>
    onChange({
      ...value,
      startDateTime: dates && dates[0] && dates[0].toISOString(),
    });

  const makeOnEndDateChange = (key: string) => (dates: Date[]) =>
    onChange({
      ...value,
      endDateTime: dates && dates[0] && dates[0].toISOString(),
    });

  return (
    <PeriodWrapper>
      <DatePickerWrapper>
        <DatePickerLabel>
          {localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.TIME_START' })}
        </DatePickerLabel>
        <Flatpickr data-enable-time={true} options={{ time_24hr: true }} onChange={makeOnStartDateChange('')} />
      </DatePickerWrapper>
      <DatePickerWrapper>
        <DatePickerLabel>{localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.TIME_END' })}</DatePickerLabel>
        <Flatpickr data-enable-time={true} options={{ time_24hr: true }} onChange={makeOnEndDateChange('')} />
      </DatePickerWrapper>
    </PeriodWrapper>
  );
};
